<div class="image-container">
  @if (value.title) {
    <h5 class="image-header">{{ value.title }}</h5>
  }
  @if (value.subtitle) {
    <h5 class="image-sub-header">
      <span>{{ value.subtitle }}</span>
    </h5>
  }
  @if (value.url !== IMAGE_NOT_FOUND) {
    <grid-ui-icon (click)="openExpander()" class="expand-icon" name="expand" ngbTooltip="Expand image" placement="top"> </grid-ui-icon>
  }
  <img
    class="image image-expander"
    [alt]="value.alt_text"
    [src]="value.url | imageResizer"
    [ngStyle]="value.url === IMAGE_NOT_FOUND ? { cursor: 'auto' } : { cursor: 'pointer' }"
    (load)="handleImageLoaded()"
    (click)="openExpander()"
    (error)="imageLoadError()"
  />
  @if (value.caption || value.attribution) {
    <div class="caption-text">
      @if (value.caption) {
        <span>{{ value.caption }}</span>
      }
      @if (value.attribution) {
        <span class="attribution-text">
          Source:
          @if (value.attribution) {
            <span [innerHTML]="value.attribution"></span>
          }
        </span>
      }
    </div>
  }
</div>
